export enum AreaAccessEnum {
  No_Access = 1,
  Limited_Access,
  Accessible
}
